import template from './form.html';
import nuevoClienteTemplate from './cliente.nuevo.html';
import nuevoAtributoClienteTemplate from './atributo-cliente.nuevo.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';
import turnosI18N from 'i18n/turnos/es.json';
import commonI18N from 'i18n/common/es.json';
import viewAtributosTemplate from './view-atributos.html';

export let TurnoFormComponent = {
  templateUrl: template,
  selector: 'turnoForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(turnosI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope', 'CustomModal', 'AuthorizationService'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, $scope, CustomModal, AuthorizationService) {

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.loadClientes = loadClientes.bind(this);
  this.loadServicios = loadServicios.bind(this);
  this.renderCliente = renderCliente.bind(this);
  this.renderServicio = renderServicio.bind(this);
  this.filterServicio = filterServicio.bind(this);
  this.cancel = cancel.bind(this);
  this.selectCategoria = selectCategoria.bind(this);
  this.selectServicio = selectServicio.bind(this);
  this.updateRazonSocial = updateRazonSocial.bind(this);
  this.nuevoCliente = nuevoCliente.bind(this);
  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.cancelarDetalle = cancelarDetalle.bind(this);
  this.loadTipoAtributo = loadTipoAtributo.bind(this);
  this.nuevoAtributoCliente = nuevoAtributoCliente.bind(this);
  this.viewAtributosCliente = viewAtributosCliente.bind(this);
  this.renderTipoAtributo = renderTipoAtributo.bind(this);
  this.buscar = buscar.bind(this);

  this.$postLink = () => {};

  Object.assign(this, { $state, $ngRedux, ngNotify });

  this.localModel = {
    nuevoDetalle: {},
    detalles: []
  };

  let unsubscribe;
  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const tipoPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tipoDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');
  const estadosFilter = Filter.path('tipo.codigo').eq('estado_turno_cabecera');

  const valoresFilter = sexoQuery.or(tipoDocumentoQuery).or(tipoPersonaQuery).or(estadosFilter);
  const parametroFilter = Filter.path('codigo').eq('inicio_agenda_diaria').or(Filter.path('codigo').eq('fin_agenda_diaria'));

  const categoriaFilter = Filter.path('clase.value').eq('Servicio');

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver turno'] : this.translations['Editar turno'];
      this.formEdit('turnos', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo turno'];
      this.form();
    }

    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
    $ngRedux.dispatch(rest.actions.categoriasProductos({ filter: JSON.stringify(categoriaFilter) }));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));

    this.canCreateAtributoCliente = AuthorizationService.hasPermission('create_atributo_cliente');
    console.log("[canCreateAtributoCliente] ", this.canCreateAtributoCliente);
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (this.model && !this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_turno_cabecera');
      let estadoEspera = this.estados.filter(v => v.value === 'En Espera')[0];
      this.model.estado = estadoEspera;
      this.model.fecha = new Date();
      this.localModel.numero = this.translations['Autogenerado'];
    } else if (!this.modelInit && this.model && this.model.id) {
      this.modelInit = true;
      this.localModel.numero = this.model.numero;
      if (this.model.detalles) {
        this.localModel.detalles = this.model.detalles;
      }
    }
    this.tiposPersona = state.valores.data.filter((v) => v.tipo.codigo === 'tipo_persona');

    return {
      form: state.form,
      categoriasProductos: state.categoriasProductos.data,
      tiposDocumento: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento')
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => {
        $state.go($stateParams.next? $stateParams.next :'home.turnos.list');
      });
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }


    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go($stateParams.next? $stateParams.next :'home.turnos.list');
    }
  }

  function doSubmit() {

    let {
      id,
      cliente: {id:clienteId},
      numero,
      fecha,
      estado
    } = this.model;

    let detalles = [];


    this.localModel.detalles.forEach(function(d) {
      let detalle = Object.assign({}, d);
      if (detalle.servicio) {
        detalle.servicio = detalle.servicio.id;
      }
      detalles.push(detalle);
    });

    if (detalles.length < 1) {
      ngNotify.set(this.translations['Debe agregar al menos un servicio'], 'warn');
      return;
    }

    let data = {
      id,
      cliente: {id:clienteId},
      detalles,
      numero,
      fecha,
      estado
    };

    this.save('turnos', data);
  }

  function renderCliente(cliente) {
    let detalle = cliente.numeroDocumento ? `<small><strong>(${cliente.numeroDocumento})</strong></small>` : '';
    return `${cliente.razonSocial} ${detalle}`;
  }

  function renderServicio(item) {
    return `${item.nombre}`;
  }

  function loadServicios(query, categoria) {
    if (!categoria) {
      return;
    }

    let filter = Filter.path('categoria.id').eq(categoria.id)
      .and(Filter.path('activo').eq(true))
      .and(Filter.path('estado.value').eq('Activo'))
      .and(Filter.path('servicioPadre.id').isNull());

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function filterServicio(servicio) {
    return servicio.precio;
  }

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('telefono').like(query)));
    } else {
      return;
    }
    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  let self = this;
  this.uiConfig = {};

  function selectCategoria() {}

  function selectServicio() {}

  function updateRazonSocial() {
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : '' } ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;
  }

  function nuevoCliente() {
    let self = this;
    this.localModel.payload = {};

    if (this.tiposDocumento) {
      this.localModel.payload.tipoDocumento = this.tiposDocumento.filter((tipo) => tipo.value === 'RUC')[0];
    }

    CustomModal.open({
      title: 'Nuevo Cliente',
      size: 'lg',
      templateUrl: nuevoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.clientes({}, { body: JSON.stringify(self.localModel.payload) },
          (err, data) => {
            if (!err && data && data.id) {
              self.model.cliente = data;
              ngNotify.set(self.translations['Nuevo Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function nuevoAtributoCliente() {
    let self = this;
    CustomModal.open({
      title: 'Nuevo Atributo de Cliente',
      size: 'lg',
      templateUrl: nuevoAtributoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: {cliente: this.model.cliente, origen: 'TURNO'},
      ok: function() {
        // Validar que se completaron los campos requeridos
        const campos = (this.payload.tipo && this.payload.tipo.campos) || [];
        const valor = this.payload.valor ||{};
        const camposRequeridosCompletados = campos
          .filter(c => c.requiredTurno)
          .map(c => c.text)
          .reduce((camposRequeridosCompletados, campoRequerido) => {
            return camposRequeridosCompletados && valor[campoRequerido];
          }, true);

        if (!camposRequeridosCompletados) {
          ngNotify.set('Campos requeridos faltantes', 'warn');
          return false;
        }

        $ngRedux.dispatch(rest.actions.atributosClientes({}, { body: JSON.stringify(this.payload) },
          (err, data) => {
            if (!err && data) {
              self.model.cliente.atributos.push(data);
              ngNotify.set(self.translations['Nuevo Atributo de Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }

    });
  }

  function viewAtributosCliente() {
    let self = this;

    // Eliminar la hora de las fechas
    (self.model.cliente.atributos || []).forEach(attr => {
      Object.keys((attr && attr.valor) || {}).forEach(key => {
        attr.valor[key] = attr.valor[key].replace(/T\d{2}:\d{2}:\d{2}.\d{3}Z/g, '');
      });
    });

    CustomModal.open({
      title: 'Atributos del Cliente',
      size: 'lg',
      templateUrl: viewAtributosTemplate,
      vm: this,
      atributos: self.model.cliente.atributos.filter(a => a.tipo.mostrarEnTableroEspecialistas),
      ok: function() {}
    });
  }

  function cancel() {
    $state.go($stateParams.next? $stateParams.next :'home.turnos.list');
  }

  this.updateRUC = updateRUC.bind(this);
  function updateRUC() {
    this.localModel.payload.nombre = this.localModel.payload.ruc.nombre;
    this.localModel.payload.apellido = this.localModel.payload.ruc.apellido;
    this.localModel.payload.numeroDocumento = this.localModel.payload.ruc.numero;
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : '' } ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;

    if (this.localModel.payload.ruc.personaFisica) {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Física')[0];
    } else {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Jurídica')[0];
      this.localModel.payload.razonSocial = this.localModel.payload.ruc.razonSocial;
    }
  }

  this.loadRUC = loadRUC.bind(this);
  function loadRUC(query) {
    let filter;

    if (query) {
      filter = Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numero').like(query));
    } else {
      return;
    }

    BasicFactory.setup('ruc');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function buscar (parametro) {
    if (parametro) {
      return $ngRedux.dispatch(rest.actions.search({ parametro: parametro }));
    } else {
      return;
    }
  }

  this.renderRUC = renderRUC.bind(this);
  function renderRUC(ruc) {
    let numeroDoc = ruc.numero && ruc.digitoVerificador ? ruc.numero + "-" + ruc.digitoVerificador : 'Sin Nro. Documento';
    return `${ruc.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  function newDetalle() {
    if (!this.localModel.nuevoDetalle || !this.localModel.nuevoDetalle.servicio)
      return;

    this.localModel.detalles.push(this.localModel.nuevoDetalle);
    this.localModel.nuevoDetalle = {};
    console.log($scope);
  }

  function deleteDetalle(detalle) {
    _.remove(this.localModel.detalles, detalle);
  }

  function cancelarDetalle(detalle) {
    CustomModal.open({
      title: 'Cancelar',
      message: '¿Desea cancelar el turno?',
      ok: function() {
        $ngRedux.dispatch(rest.actions.cancelarTurnoDetalle({ id: detalle.id }, {
          body: JSON.stringify({})
        }, (err, data) => {
          if (!err && data.estado.value == 'Cancelado') {
            ngNotify.set(self.translations['Cancelado Correctamente'], 'success');
            // Actualizar lista de detalles para que la tabla refleje el nuevo estado del detalle cancelado
            self.localModel.detalles = self.localModel.detalles.map((d)=>{
              return d.id === data.id? data : d;
            });
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });

  }

  function loadTipoAtributo(query) {

    if (query) {
      var filter = Filter.path('nombre').like(query);
      filter = filter.or(Filter.path('abreviatura').like(query));
    }
    BasicFactory.setup('tipos-atributos-cliente');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderTipoAtributo(tipo) {
    let detalle = tipo.abreviatura ? `<small><strong>(${tipo.abreviatura})</strong></small>` : '';
    return `${tipo.nombre} ${detalle}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/turnos/form/form.component.js